<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="text-h6">Servicios</span>
        <v-spacer></v-spacer>
        <v-btn
          class="mr-4"
          title="Listado de Servicios"
          small
          color="primary"
          @click="$emit('changeView', 'listado')"
        >
          <v-icon>mdi-format-list-bulleted</v-icon>
        </v-btn>
        <v-btn
          title="Agregar Servicio"
          small
          color="primary"
          @click="$emit('changeView', 'nuevo')"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-row class="fill-height">
        <v-col>
          <v-sheet height="64">
            <v-toolbar flat>
              <v-btn
                outlined
                class="mr-4"
                color="grey darken-2"
                @click="setToday"
              >
                Today
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="prev">
                <v-icon small>mdi-chevron-left</v-icon>
              </v-btn>
              <v-btn fab text small color="grey darken-2" @click="next">
                <v-icon small>mdi-chevron-right</v-icon>
              </v-btn>
              <v-toolbar-title v-if="$refs.calendar">
                {{ $refs.calendar.title }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-menu bottom right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    outlined
                    color="grey darken-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <span>{{ typeToLabel[type] }}</span>
                    <v-icon right>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="type = 'day'">
                    <v-list-item-title>Day</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'week'">
                    <v-list-item-title>Week</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = 'month'">
                    <v-list-item-title>Month</v-list-item-title>
                  </v-list-item>
                  <v-list-item @click="type = '4day'">
                    <v-list-item-title>4 days</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <v-select
                v-model="selectedYear"
                :items="yearOptions"
                label="Año"
                dense
                outlined
                hide-details
                class="ml-4"
                style="max-width: 100px"
                @change="goToSelectedYear"
              />
            </v-toolbar>
          </v-sheet>
          <v-sheet height="600">
            <v-calendar
              locale="es"
              ref="calendar"
              v-model="focus"
              color="primary"
              :events="events"
              :event-color="getEventColor"
              :type="type"
              @click:event="showEvent"
              @click:more="viewDay"
              @click:date="viewDay"
              @change="updateRange"
            ></v-calendar>
            <v-menu
              v-model="selectedOpen"
              :close-on-content-click="false"
              :activator="selectedElement"
              offset-x
            >
              <v-card color="grey lighten-4" min-width="350px" flat>
                <v-toolbar :color="selectedEvent.color" dark>
                  <v-toolbar-title>{{ selectedEvent.name }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </v-toolbar>
                <v-card-text>
                  <div>
                    <strong>Estado:</strong>
                    <v-chip class="ma-2" small>
                      {{ selectedEvent.status }}
                    </v-chip>
                  </div>
                  <div>
                    <strong>Cliente:</strong>
                    {{
                      `${selectedEvent.client.first_name} ${
                        selectedEvent.client.last_name ?? ""
                      }`
                    }}
                  </div>
                  <div>
                    <strong>Vehículo:</strong>
                    {{
                      selectedEvent.vehicle.make +
                      " " +
                      selectedEvent.vehicle.model
                    }}
                  </div>
                  <div>
                    <strong>Descripcion:</strong>
                    {{ selectedEvent.template ? selectedEvent.template.description : 'Servicio/Revisión' }}
                  </div>
                  <div><strong>Km:</strong> {{ selectedEvent.km_in }}</div>
                  <div style="color: brown" v-if="!selectedEvent.vehicle.plate && selectedEvent.status == 'pendiente'">
                    <strong>SIN PATENTE: </strong>No puede iniciar el checkin
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn color="blue-grey" @click="selectedOpen = false">
                    Cerrar
                  </v-btn>
                  <v-btn
                    v-if="selectedEvent.status == 'pendiente'"
                    :disabled="!selectedEvent.vehicle.plate"
                    color="info"
                    @click="initCheckIn(selectedEvent)"
                  >
                    Iniciar Check-in
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </v-sheet>
        </v-col>
      </v-row>
      <v-overlay :value="overlay" :z-index="3000">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-container>
</template>
  
  <script>
import axios from "@/plugins/axios.js";
import VehicleForm from "@/components/VehicleForm.vue";
import client from "@/components/Client.vue";
export default {
  components: { VehicleForm, client },

  data: () => ({
    vehicle: {
      id: null,
      make: "",
      model: "",
      year: "",
      version: "",
      plate: "",
      color: "",
      //price: 0,
      position: "",
      factory_id: "",
      vin: "",
      motor_number: "",
    },
    selectedYear: new Date().getFullYear(),
    yearOptions: Array.from(
      { length: 10 },
      (_, i) => new Date().getFullYear() - 5 + i
    ),
    focus: new Date().toISOString().substr(0, 10),
    selectedEvent: {
      template: null,
      client: null,
      vehicle: null,
      km_in: null,
      start: null,
      end: null,
    },
    clients: [],
    vehicles: [],
    searchClient: "",
    searchVehicle: "",
    isCalendar: true,
    focus: "",
    type: "month",
    typeToLabel: {
      month: "Mes",
      week: "Semana",
      day: "Día",
      "4day": "4 Días",
    },
    selectedEvent: {
      template: {
        name: null,
      },
      client: {
        name: null,
      },
      vehicle: {
        name: null,
      },
    },
    selectedElement: null,
    selectedOpen: false,
    events: [],
    colors: [
      "blue",
      "indigo",
      "deep-purple",
      "cyan",
      "green",
      "orange",
      "grey darken-1",
    ],
    overlay: false,

    visibleFields: [
      "make",
      "model",
      "year",
      "version",
      "plate",
      //"price",
      "chassis_number",
      "color",
      "position",
      "factory_id",
      "motor_number",
      "vin",
    ],
  }),
  mounted() {
    this.getServices();
  },
  computed: {
    completeName() {
      if (!this.clientSelected.first_name) return null;
      return `${this.clientSelected.first_name} ${this.clientSelected.last_name}`;
    },
  },
  methods: {
    goToSelectedYear() {
      // Esto cambia la vista del calendario al 1 de enero del año seleccionado
      this.focus = `${this.selectedYear}-01-01`;
    },
    updateRange({ start }) {
      const year = new Date(start).getFullYear();
      this.selectedYear = year;
    },
    initCheckIn(item) {
      this.$router.push({
        name: "checkin",
        query: { item: JSON.stringify(item) },
      });
    },
    resetForm() {
      this.template = null;
      this.plate = "";
      this.vehicleSelected = { make: "", model: "" };
      this.dni = "";
      // this.completeName = '';
      this.clientSelected = { address: "", first_name: "", last_name: "" };
      this.kmIn = "";
      this.date = "";
      this.timeFrom = "";
      this.timeTo = "";
    },

    fetchClient() {
      this.overlay = true;
      axios
        .get("/clients/getClient", {
          params: {
            dni: this.dni,
          },
        })
        .then((response) => {
          if (!response.data) {
            //msg de aviso para realizar carga
            return;
          }
          this.clientSelected = response.data;
        })
        .catch((err) => {
          console.error("Error al obtener recursos:", err);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fetchVehicles() {
      this.overlay = true;
      axios
        .get("/vehicles/getVehicle", {
          params: {
            plate: this.plate,
          },
        })
        .then((response) => {
          if (!response.data) {
            //msg de aviso para realizar carga
            return;
          }
          this.vehicleSelected = response.data;
          if (this.vehicleSelected.client) {
            this.clientSelected = this.vehicleSelected.client;
            this.dni = this.clientSelected.dni;
          }
        })
        .catch((err) => {
          console.error("Error al obtener recursos:", err);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getServices() {
      this.overlay = true;
      axios
     .get("/services/getServices")
.then((response) => {
  let data = [...response.data];
  this.events = data.map((e) => {
    const [datePart, timePart] = e.start.split(' ');
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours = 0, minutes = 0] = (timePart || '00:00').split(':').map(Number);
    const fullYear = year < 100 ? 2000 + year : year;
    // Construimos manualmente el formato "YYYY-MM-DD HH:mm"
    const formattedDate = `${fullYear}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')} ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;    
    return {
      ...e,
      start: formattedDate,
      end: formattedDate, // o agregá +1h si querés duración
      color: this.colors[Math.floor(Math.random() * this.colors.length)],
      name: e.template ? e.template.name : e.service_lines[0].observation,
    };
  });


          this.overlay = false;
        })
        .catch(() => {
          this.overlay = false;
        });
    },
    viewDay({ date }) {
      this.focus = date;
      this.type = "day";
    },
    getEventColor(event) {
      return event.color;
    },
    setToday() {
      this.focus = "";
    },
    updateRange({ start, end }) {
      // Puedes añadir más eventos dinámicos aquí si es necesario
    },
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },
    showEvent({ nativeEvent, event }) {
      this.selectedEvent = event;
      this.selectedElement = nativeEvent.target;
      this.selectedOpen = true;
      nativeEvent.stopPropagation();
    },
  },
};
</script>
  